<section class="stc-premios-aniv">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h1>
            PREMIOS
          </h1>
        </div>
        <div class="col-md-12">
          <div class="content-img">
            <img src="/assets/images/sorteo2025/audi.png" alt="Audi"
              class="img-fluid d-lg-inline-block d-md-none  d-sm-none">
            <img src="/assets/images/sorteo2025/byd.png" alt="BYD" class="img-fluid d-lg-inline-block d-sm-none">
  
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  <section class="audi">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <h2>¡ACELERA, COMPRA Y GANA!</h2>
        </div>
        <div class="col-lg-9 my-auto">
          <img src="/assets/images/sorteo2025/car-audi.png" alt="BYD" class="img-fluid byd" >
        </div>
  
        <div class="col-lg-3 text-center my-auto">
          <p>
            fecha del sorteo
            <span class="d-block">
              18 sep 2025
            </span>
          </p>
  
          <p>
            precio del boleto
            <span class="d-block">
              $700
            </span>
          </p>
  
          <p>
            10 autos
  
          </p>
  
          <a href="{{ urlMicrositioAniv }}" target="_blank" class="btn-stack">¡COMPRA YA!</a>
        </div>
      </div>
    </div>
  </section>
  
  <section class="cta-aniv">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center">
          <h3>
            10 <span>AÑOS CELEBRANDO CONTIGO</span>
          </h3>
        </div>
      </div>
    </div>
  </section>
  
  
  
  
  
  <section class="cars">
    <div class="container">
      <div class="row">
  
        <div class="col-12 text-center">
          <h3>
            CONOCE LOS PREMIOS
          </h3>
        </div>
  
        <ng-container *ngIf="!isSmallScreen">
          <ng-container *ngFor="let premio of premios; let i = index">
  
            <!-- Alternar el orden de los elementos -->
            <div *ngIf="i % 2 === 0" class="col-md-8">
              <div [id]="premio.id" class="carousel slide" data-ride="false">
                <div class="carousel-inner">
                  <div *ngFor="let img of premio.imagenes; let first = first" class="carousel-item"
                    [ngClass]="{'active': first}">
                    <ng-container *ngIf="img.includes('youtube')">
                      <youtube-player 
                        [videoId]="getVideoId(img)" 
                        [height]="400" 
                        [width]="'100%'">
                      </youtube-player>
                    </ng-container>
                    <!-- Mostrar imagen si no es un video -->
                    <ng-container *ngIf="!img.includes('youtube')">
                      <img [src]="img" class="d-block w-100" [alt]="premio.nombre">
                    </ng-container>
                  </div>
                </div>
                <a class="carousel-control-prev" [href]="'#' + premio.id" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                </a>
                <a class="carousel-control-next" [href]="'#' + premio.id" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                </a>
              </div>
            </div>
  
            <div class="col-md-4 my-auto" [ngClass]="{'text-right': i % 2 !== 0}">
              <h4>{{ premio.titulo }}</h4>
              <p class="text-uppercase">{{ premio.nombre }}
                <span class="d-block">{{ premio.modelo }}</span>
              </p>
              <p>
                <small>PRECIO DEL BOLETO</small>
                <strong class="d-block">${{ premio.precioBoleto }}</strong>
              </p>
              <a href="{{ urlMicrositioAniv }}" target="_blank" class="btn-stack">¡COMPRA YA!</a>
  
              <p *ngIf="premio.valor" class="mt-4">
                <small> VALOR</small>
                <small class="d-block f-bold">${{ premio.valor | number:'1.2-2' }}</small>
              </p>
            </div>
  
            <!-- Si la iteración es impar, entonces mostramos la imagen después -->
            <div *ngIf="i % 2 !== 0" class="col-md-8">
              <div [id]="premio.id" class="carousel slide" data-ride="false">
                <div class="carousel-inner">
                  <div *ngFor="let img of premio.imagenes; let first = first" class="carousel-item"
                    [ngClass]="{'active': first}">
                    <ng-container *ngIf="img.includes('youtube')">
                      <youtube-player 
                        [videoId]="getVideoId(img)" 
                        [height]="400" 
                        [width]="'100%'">
                      </youtube-player>
                    </ng-container>
                    <!-- Mostrar imagen si no es un video -->
                    <ng-container *ngIf="!img.includes('youtube')">
                      <img [src]="img" class="d-block w-100" [alt]="premio.nombre">
                    </ng-container>
                  </div>
                </div>
                <a class="carousel-control-prev" [href]="'#' + premio.id" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                </a>
                <a class="carousel-control-next" [href]="'#' + premio.id" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                </a>
              </div>
            </div>
  
          </ng-container>
        </ng-container>
  
  
  
        <ng-container *ngIf="isSmallScreen">
          <ng-container *ngFor="let premio of premios; let i = index">
            <!-- Bloque de Texto para los premios -->
            <div *ngIf="i % 2 === 0" class="col-12 col-md-4 my-auto">
              <h4>{{ premio.titulo }}</h4>
              <p>{{ premio.nombre }}
                <span class="d-block">{{ premio.modelo }}</span>
              </p>
              <p>
                <small>PRECIO DEL BOLETO</small>
                <strong class="d-block">${{ premio.precioBoleto }}</strong>
              </p>
              <a href="" class="btn-stack">¡COMPRA YA!</a>
  
              <p *ngIf="premio.valor" class="mt-4">
                <small> VALOR</small>
                <small class="d-block f-bold">${{ premio.valor | number:'1.2-2' }}</small>
              </p>
            </div>
  
            <!-- Bloque de Slider para los premios -->
            <div *ngIf="i % 2 === 0" class="col-12 col-md-8">
              <div [id]="premio.id" class="carousel slide" data-ride="false">
                <div class="carousel-inner">
                  <div *ngFor="let img of premio.imagenes; let first = first" class="carousel-item"
                    [ngClass]="{'active': first}">
                    <ng-container *ngIf="img.includes('youtube')">
                      <youtube-player 
                        [videoId]="getVideoId(img)" 
                        [height]="192" 
                        [width]="'100%'">
                      </youtube-player>
                    </ng-container>
                    <!-- Mostrar imagen si no es un video -->
                    <ng-container *ngIf="!img.includes('youtube')">
                      <img [src]="img" class="d-block w-100" [alt]="premio.nombre">
                    </ng-container>
                  </div>
                </div>
                <a class="carousel-control-prev" [href]="'#' + premio.id" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                </a>
                <a class="carousel-control-next" [href]="'#' + premio.id" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                </a>
              </div>
            </div>
  
            <!-- Bloque de Texto (Este solo se mostrará si la iteración es impar) -->
            <div *ngIf="i % 2 !== 0" class="col-12 col-md-4 my-auto">
              <h4>{{ premio.titulo }}</h4>
              <p>{{ premio.nombre }}
                <span class="d-block">{{ premio.modelo }}</span>
              </p>
              <p>
                <small>PRECIO DEL BOLETO</small>
                <strong class="d-block">${{ premio.precioBoleto }}</strong>
              </p>
              <a href="" class="btn-stack">¡COMPRA YA!</a>
  
              <p *ngIf="premio.valor" class="mt-4">
                <small> VALOR</small>
                <small class="d-block f-bold">${{ premio.valor | number:'1.2-2' }}</small>
              </p>
            </div>
  
            <!-- Bloque de Slider (Este solo se mostrará si la iteración es impar) -->
            <div *ngIf="i % 2 !== 0" class="col-12 col-md-8">
              <div [id]="premio.id" class="carousel slide" data-ride="false">
                <div class="carousel-inner">
                  <div *ngFor="let img of premio.imagenes; let first = first" class="carousel-item"
                    [ngClass]="{'active': first}">
                    <ng-container *ngIf="img.includes('youtube')">
                      <youtube-player 
                        [videoId]="getVideoId(img)" 
                        [height]="192" 
                        [width]="'100%'">
                      </youtube-player>
                    </ng-container>
                    <!-- Mostrar imagen si no es un video -->
                    <ng-container *ngIf="!img.includes('youtube')">
                      <img [src]="img" class="d-block w-100" [alt]="premio.nombre">
                    </ng-container>
                  </div>
                </div>
                <a class="carousel-control-prev" [href]="'#' + premio.id" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                </a>
                <a class="carousel-control-next" [href]="'#' + premio.id" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </ng-container>
        </ng-container>
  
  
  
        <div class="col-12 text-center m-4">
          <small><strong>Imágenes ilustrativas</strong></small>
        </div>
      </div>
    </div>
  </section>
  
  
  <section class="bottom-cta">
    <div class="container">
      <div class="row">
        <div class="col-md-6  my-auto">
          <img src="/assets/images/sorteo2025/fly.png" alt="" class="img-fluid">
        </div>
        <div class="col-md-6 text-center my-auto pt-4">
          <p>
            <strong>Colabora</strong> y <strong>gana</strong> un <strong>viaje</strong>
          </p>
          <!-- <a routerLink="/formulario-registro-colaboradores" class="btn-stack">Colabora</a> -->
        </div>
      </div>
    </div>
  </section>
  